import XLSX from "xlsx-js-style";
import { buildHeaderRows, buildReportFilename } from "@/utils/reportExport";
import { claimsExportRows } from "@/utils/reconciliation";

const PAYER_LABEL = { SSO: "ประกันสังคม", NHSO: "สปสช." };
const STATUS_LABEL = { outstanding: "ค้างรับ", paid: "รับแล้ว" };

/**
 * Save the rows a reconciliation tab is showing as .xlsx, with the same title/date/branch header
 * and file naming as the other reports (reportExport.js).
 */
export function exportClaimsToExcel({ rows, payer, status, dateFrom, dateTo, doctorName, branchName, clinicName }) {
  const reportTitle = `กระทบยอด ${PAYER_LABEL[payer]} · ${STATUS_LABEL[status]}`;
  const header = buildHeaderRows({ reportTitle, dateFrom, dateTo, doctorName, branchName, clinicName });
  // buildHeaderRows already ends with a blank spacer row
  const ws = XLSX.utils.aoa_to_sheet([...header, ...claimsExportRows({ rows, payer, status })]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, STATUS_LABEL[status]);
  const filename = buildReportFilename({ reportNameEn: `Reconcile_${payer}_${status}`, doctorName, dateFrom, dateTo });
  XLSX.writeFile(wb, filename);
  return filename;
}
